import { Component, OnInit } from '@angular/core';
import { Sort, PageEvent, MatPaginator } from '@angular/material';
import {ExportHubService} from '../exporting-hub/service/export-hub.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-export-hub-logs',
  templateUrl: './export-hub-logs.component.html',
  styleUrls: ['./export-hub-logs.component.css']
})
export class ExportHubLogsComponent implements OnInit {
  exportLogs: any=[];
  query: any;
  pageSize: Number = 10;
  count :Number = 0;
  public isLoading: Boolean = false;

  constructor(private exportHubSrv:ExportHubService,private datePipe: DatePipe) { }

  ngOnInit() {
    this.query = {
      sort: { 'personalInformation.familyName': 1 },
      pagination: {
        pageIndex: 0,
        pageSize: this.pageSize
      }
    };
    this.getLogsList();
  }
  getServerData(event) {
    this.query.pagination.pageIndex = event.pageIndex;
    this.query.pagination.pageSize = event.pageSize;
    this.getLogsList();
}
  sortData(sort: Sort) {
    this.query.sort = {};
    if (sort.direction === 'asc') {
      this.query.sort[sort.active] = -1;
    } else if (sort.direction === 'desc') {
      this.query.sort[sort.active] = 1;
    }
    this.getLogsList();
  }
  getLogsList(){
    this.isLoading = true;
    this.exportHubSrv.getExportHubLogs(this.query).then((data:any)=>{
      console.log(data)
      this.isLoading =false
      this.exportLogs = data.data;
      this.count = data.count;
      console.log(this.count)
      this.exportLogs.forEach((item:any) => {
        item.time = this.datePipe.transform(item.time, 'yyyy-MM-dd');
      });
    }).catch(err =>{
      this.isLoading = false;
      console.log("[Get logs error]",err)
    })
  }
}
